import {
  screenSmMax,
  screenXsMax,
  spacer12,
  spacer24,
  spacer20,
  spacer32,
  spacer40,
  spacer64,
} from '@spotify-internal/encore-foundation';
import { Type, TypeList, TypeListItem } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { transformScaleUp } from '../../utils';

export const FooterWrapper = styled.footer`
  padding: ${spacer40};
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  background: ${({ theme }) => theme.box.background};

  &,
  & a {
    color: ${({ theme }) => theme.nav.text};
  }

  a:focus img {
    ${transformScaleUp};
  }

  @media (max-width: ${screenSmMax}) {
    padding: ${spacer40} ${spacer20};
  }

  ${TypeList.ul} {
    list-style: none;
    padding-left: 0;
  }
`;

export const Copyright = styled(Type.small).attrs({
  variant: 'body2',
})``;

export const FooterSection = styled.div`
  header {
    padding-right: ${spacer64};
  }

  &:first-of-type {
    /* logo */
    flex: 1;
  }

  :not(:first-of-type),
  :not(:last-of-type) {
    margin-right: ${spacer40};
  }

  &:last-of-type {
    /* copyright */
    width: 100%;
  }

  ${TypeList.ul} {
    margin-bottom: ${spacer32};
    ${TypeListItem} {
      margin: ${spacer12} 0;
    }
  }

  @media (max-width: ${screenXsMax}) {
    width: 100%;
    &:first-of-type {
      margin-bottom: ${spacer24};
    }
  }
`;

export const SectionHeader = styled(Type.h2).attrs({
  variant: Type.body1,
  weight: Type.bold,
  condensed: true,
})``;

export const InlineList = styled(TypeList.ul)`
  display: flex;
  flex-flow: row nowrap;
`;

export const CircleIcon = styled.div`
  color: ${({ theme }) => theme.nav.text};
  border: 1px solid ${({ theme }) => theme.nav.text};
  border-radius: 100%;
  width: 42px;
  height: 42px;
  padding: ${spacer12};
  margin-right: ${spacer12};
`;
